import React, { useContext } from "react";

import lbl from "../../../data/Labels.json";

import { PopUpContext } from "../../../contexts/popUpContext";
import useParityAccess, { useAccessReady } from "../../common/useParityAccess";

const PastBalanceBtn = ({ data, cache }) => {
  const { togglePopUp } = useContext(PopUpContext);
  const can = useParityAccess();
  const ready = useAccessReady();
  if (ready && !can("edit-student-balance")) return null;

  return data?.summary?.past_balance_id ? (
    <div className="download-balance-btn-area">
      <button
        onClick={() =>
          togglePopUp({
            form: "student-past-balance-pop-up",
            cache,
          })
        }
      >
        {lbl.OpeningBalance}
      </button>
    </div>
  ) : null;
};

export default PastBalanceBtn;
